
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '../static/assets/plugins/bootstrap_v4.1.1/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../static/assets/plugins/materialdesignicons/css/materialdesignicons.min.css'
import '../static/assets/styles/scss/swiper.css'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import '../static/assets/styles/scss/template.scss'
import Toasted from 'vue-toasted'
// import '../static/js/fbSdk.js'
import md5 from '../static/js/md5.min'
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueCarousel from 'vue-carousel'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../static/assets/styles/scss/vue-animate.css'
require('vue-animate/dist/vue-animate.min.css')
import VueScrollReveal from 'vue-scroll-reveal'
import BackToTop from 'vue-backtotop'
import store from './store'
import MKCLAPI from '../static/js/ssomodule.js'
import axios from 'axios'
import vuexI18n from 'vuex-i18n'
import translationsEn from '@/../static/localization/en.json'
import translationsMr from '@/../static/localization/mr.json'
import VueProgressBar from 'vue-progressbar'
import Vuebar from 'vuebar'
import Moment from 'vue-moment-jalaali'
import {SSO_CLIENT_ID, MKCL_LOGIN_SERVER_URL, MKCL_LOGIN_CLIENT_URL, MKCL_SIGNUP_URL, FACEBOOK_LOGIN_APP_ID, GOOGLE_ANALYTICS_ID} from '@/components/common/constants.js'
import VueLazyload from 'vue-lazyload'
import VueSwal from 'vue-swal'
import vueScrollto from 'vue-scrollto'
import SocialSharing from 'vue-social-sharing'
import datePicker from 'vue-bootstrap-datetimepicker'
import veeValidate from 'vee-validate'
// import GSignInButton from 'vue-google-signin-button'
// import FBSignInButton from 'vue-facebook-signin-button'
const InfiniteLoading = require('vue-infinite-loading')
import VueAnalytics from 'vue-analytics'
const isProd = process.env.NODE_ENV !== 'production'
// stg ga id:UA-121174698-1
Vue.use(VueAnalytics, {
  id: 'UA-121063410-1',
  router,
  autoTracking: {
    exception: true
  },
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
})
Vue.use(VueProgressBar, {
  color: '#ADFF2F',
  failedColor: 'red'
})
Vue.use(vuexI18n.plugin, store)
Vue.use(Moment)
Vue.i18n.add('en', translationsEn)
Vue.i18n.add('mr', translationsMr)
// set the start locale to use
if (process.env.NODE_ENV !== "development") {
  if (process.env.NODE_ENV === "mahademy") {
    Vue.i18n.set('mr')
  } else {
    Vue.i18n.set('en')
  }
} else {
  Vue.i18n.set('en')
}  
window.axios = axios
Vue.use(MKCLAPI, {
  clientId: SSO_CLIENT_ID,
  mkclLoginServerURL: MKCL_LOGIN_SERVER_URL,
  mkclLoginClientURL: MKCL_LOGIN_CLIENT_URL,
  mkclSignUpURL: MKCL_SIGNUP_URL
})
Vue.config.productionTip = false
// Vue.use(GSignInButton)
// Vue.use(FBSignInButton)
Vue.use(datePicker)
Vue.use(vueScrollto)
Vue.use(VueSwal)
Vue.use(SocialSharing)
Vue.use(VueLazyload, {
})
Vue.use(veeValidate)
Vue.use(VueCarousel)
Vue.use(VueAwesomeSwiper)
Vue.use(BootstrapVue)
Vue.use(VueScrollReveal)
Vue.use(BackToTop)
Vue.use(Vuebar)
Vue.use(Toasted, {
  duration: 3200,
  theme: 'primary'
})
// Vue.use(CryptoJS)




// Google analyitcs
export var gAnalysis = () => {
  window.dataLayer = window.dataLayer || []
  function gtag () { dataLayer.push(arguments) }
  gtag('js', new Date())
  gtag('config', 'UA-121174698-1')
}

// event bus for deciding nav buttons or search bar on header 
export const EventBus = new Vue()
// initializeFaceBookSDK - register FB sdk
/* export const initializeFaceBookSDK = () => {
  window.fbAsyncInit = function() {
    var obj = {
      appId: FACEBOOK_LOGIN_APP_ID,
      cookie: true,  // enable cookies to allow the server to access the session
      xfbml: true,  // parse social plugins on this page
      version: 'v2.8' // use graph api version 2.8
    }
    // console.log(JSON.stringify(FB))
    if (FB !== undefined) {
      FB.init(obj)
    }
  }
} */

// create md5 encrytion
export var encrtpyDetailsUsingMd5 = (str) => {
  return new Promise((resolve) => {
    // console.log(md5(str))
    // console.log(md5(str, PASSWORD_ENCRYPION_KEY))
    resolve(md5(str))
  })
}
export var base64Encode = (str) => {
  return new Promise((resolve) => {
    // console.log(str)
    var encodedString = btoa(str)
    console.log(encodedString)
    // return encodedString
    resolve(encodedString)
  })
} 
export var base64Decode = (str) => {
  var decodedString = atob(str)
  // console.log(decodedString)
}
// facebookUserDetails - returns user facebook details
export const facebookUserDetails = () => {
  return new Promise((resolve) => {
    FB.api('/me', dude => {
      resolve(dude)
    })
  })
}  
// vis - used to check if current tab is active or not
var vis = (function () {
  var stateKey, eventKey
  var keys = {
    hidden: 'visibilitychange',
    webkitHidden: 'webkitvisibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange'
  }
  for (stateKey in keys) {
    if (stateKey in document) {
      eventKey = keys[stateKey]
      break
    }
  }
  return function (c) {
    if (c) document.addEventListener(eventKey, c)
    return !document[stateKey]
  }
})()


vis(function () {
  
  if (localStorage.getItem('isLoggedIn') !== null) {
    if (vis()) {
      // tween resume() code goes here
      setTimeout(function () {
        // console.log('tab is visible - has focus')
        if (localStorage.getItem('token') !== null) {
          // var tokenTakenFromSSO = (localStorage.getItem('ssoToken') === 'true')
          axios
          .get('/o/loginForSocialUser', {headers: {'clientId': SSO_CLIENT_ID, 'Authorization': localStorage.getItem('token')}})
          .then(function (response) {
            if (response.status === 200) {
              var userData = response.data
              store.commit('clearCartData')
              store.commit('setCartData', userData.cartDetails)
              // console.log(JSON.stringify(userData.cartDetails))
              store.commit('setProfileDetails', userData.profileDetails)
              store.commit('setWishListStoreData', userData.wishListItems)
              store.commit('setUserPlaylists', userData.userPlaylists)
              store.commit('setItemsEnrolled', userData.enrolledLearningObject) // storing all LOs and COs purchased by user
              store.commit('setIsLoggedIn', true)
              localStorage.setItem('isLoggedIn', true)
            }
          }).catch(function (e) {
            console.log(e)
          })
        } else {
          // console.log(localStorage.getItem('isLoggedIn'))
          if (localStorage.getItem('isLoggedIn') == null) {
            // console.log('logging out')
            router.push({ path: '/advertisement' })
            store.dispatch('clearUserData')
          }
        }
      }, 100)
    } else {
      // console.log('tab is invisible - has blur') 
    }
  } else {
    store.dispatch('clearUserData')
  }
})

if (localStorage.getItem('isLoggedIn')) {
  var sessionObj = JSON.parse(sessionStorage.vuex)
  if (sessionObj.profile.profileDetails === null || sessionObj.profile.profileDetails.profileId === undefined) {
    // console.log('in other tab : need for getting session')
    axios.get('/server/o/loginForSocialUser', {headers: {'clientId': SSO_CLIENT_ID, 'Authorization': localStorage.getItem('token')}}).then(function (response) {
      if (response.status === 200) {
        var userData = response.data
        store.commit('setCartData', userData.cartDetails)
        store.commit('setProfileDetails', userData.profileDetails)
        store.commit('setWishListStoreData', userData.wishListItems)
        store.commit('setUserPlaylists', userData.userPlaylists)
        store.commit('setItemsEnrolled', userData.enrolledLearningObject) // storing all LOs and COs purchased by user
        store.commit('setIsLoggedIn', true)
        localStorage.setItem('isLoggedIn', true)
      }
    }).catch(function (e) {
      console.log('Failed to initialize user Profile' + e.response.data)
      localStorage.removeItem('isLoggedIn')
    })
  } else {
    // console.log('in same tab : no need for getting session')
  }
}

if (process.env.NODE_ENV === 'development') {
  // set baseUrl from app
  axios.defaults.baseURL = 'http://localhost:8083/server'
  window.serverPath = axios.defaults.baseURL
} else {
  // for prod
  // axios.defaults.baseURL = '/'
  // window.serverPath = window.location.origin
  axios.defaults.baseURL = '/server/'
  // window.serverPath = process.ServerURL
}

axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  var tokenString = window.MKCLAPI.getToken()
  if (tokenString != null) {
    config.headers.Authorization = tokenString
  } else {
    if (localStorage.getItem('token') !== null) { // user had logged in
      config.headers.Authorization = localStorage.getItem('token')
    } else { // user had not logged in and is reseting password
      
      config.headers.Authorization = localStorage.getItem('tokenForPasswordChange')
      // console.log('removing')
      localStorage.removeItem('tokenForPasswordChange')
    }
  }
  // console.log(tokenString)
  return config
}, function (error) {
  // Do something with request error
  console.log('intercept error')
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response !== null && error.response.status === 401) {
    if (error.response.data === 'ERR_ACCOUNT_DEACTIVATED') {
      Vue.toasted.error('your account seems to be deactivated')
    }
    store.dispatch('clearUserData')
    router.push({ path: '/home' })
    window.MKCLAPI.removeToken()
    window.MKCLAPI.login()
  } else {
    return Promise.reject(error)
  }
})

router.beforeEach(function (to, from, next) {
  // console.log('router')
  // alert('before each')
  if (localStorage.getItem('app_env') !== 'mahademy' && localStorage.getItem('app_env') !== undefined && localStorage.getItem('app_env') !== null) {
    // console.log('in')
    if (to.matched.some(record => record.meta.requireAuth)) {
      var token = window.MKCLAPI.getToken()
      // console.log('in', token)
      window.MKCLAPI.isTokenValid(token).then(function () {
        next()
      }).catch(function () {
        // console.log('here')
        store.dispatch('clearUserData')
        router.push({ path: '/home' })
        MKCLAPI.login()
      })
    } else {
      // console.log(JSON.stringify(to))
      next()
    }
  } else {
    // console.log('else')
    next()
  }  
})

var featureEnableList = null;

if (featureEnableList == null) {
  axios.get('o/features/getfeaturesinfolist')
  .then(res => {
    featureEnableList = res.data
  })
  .catch(e => {
    console.log('error in getting feature list : ', e)
  })
}

Vue.mixin({
  data: function () {
    return {
      get featureStatusInfoList() {
        return featureEnableList
      }
    }
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App, InfiniteLoading }
})



// WEBPACK FOOTER //
// ./src/main.js